import type { ListingFieldsFragment } from "~graphql/generated/graphql"
import { ListingType } from "~graphql/generated/graphql"

export function getListingType(listing: ListingFieldsFragment) {
    return listing.type ?? ListingType.Hunting
}

export function isHuntingType(type: ListingType | null | undefined) {
    return type === ListingType.Hunting
}

export function isBlastCastType(type: ListingType | null | undefined) {
    return type === ListingType.BlastCast
}

export function isLodgingOnlyType(type: ListingType | null | undefined) {
    return type === ListingType.LodgingOnly
}
